<template>
  <div class="Expander"
    @click="click"
    :class="elClass">

    <icon class="Expander-icon" name="plus" width="13.95px" height="13.95px" />

  </div>
</template>

<script>
import Icon from 'components/Icon'

export default {
  name: 'Expander',

  components: {
    Icon
  },

  props: {
    active: {
      type: Boolean,
      default: false
    },
    lock: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isExpanded: false
    }
  },

  computed: {
    elClass () {
      return {
        'Expander--isExpanded': this.isExpanded
      }
    }
  },

  created () {
    this.isExpanded = this.active
  },

  watch: {
    active () {
      this.isExpanded = this.active
    }
  },

  methods: {
    /**
     * Handle click event
     */
    click () {
      if (this.lock) return
      this.isExpanded = !this.isExpanded
    }
  }
}
</script>

<style>
.Expander {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  background-color: var(--color-3);
  border: 2px solid var(--color-1);
  border-radius: 50%;
  transition: all 0.5s ease;
  transform-origin: 50% 50%;
}

.Expander--isExpanded {
  transform: rotate(-135deg);
  background-color: var(--color-1);
  border-color: var(--color-3);
}

.Expander-icon svg {
  fill: var(--color-1);
  transition: all 0.5s ease;
}

.Expander--isExpanded .Expander-icon svg {
  fill: var(--color-3);
}
</style>



// WEBPACK FOOTER //
// Expander.vue?da44e924